/**
 * カスタマイズDateクラス
 */
export class DateTime {
    // インスタンス変数
    dateTime: Date;

    constructor(dateTime: Date) {
        this.dateTime = new Date(dateTime);
    }

    /**
     * このDateTimeをHH:mm形式の文字列に変換し返却します
     *
     * @returns HH:mm
     */
    getHHmm(): String {
            if (isNaN(this.dateTime.getTime())) return ""; // 不正な日時の場合は空文字を返す
        const hours = this.dateTime.getHours().toString().padStart(2, "0"); // 時間を2桁にフォーマット
        const minutes = this.dateTime.getMinutes().toString().padStart(2, "0"); // 分を2桁にフォーマット
        return `${hours}:${minutes}`;
    };

    /**
     * このDateTimeが本日であるかを判定します
     *
     * @returns boolean
     */
    isToday(): boolean {
        if (isNaN(this.dateTime.getTime())) return false; // 不正な日時の場合はfalseを返す

        const today = new Date();
        return (
            this.dateTime.getFullYear() === today.getFullYear() &&
            this.dateTime.getMonth() === today.getMonth() &&
            this.dateTime.getDate() === today.getDate()
        );
    }
}
